import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","justify-content":"center","place-items":"center"} }


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingComponent',
  props: {
    size: { default: "1x" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_font_awesome_icon, {
      icon: "fa-solid fa-spinner",
      size: __props.size,
      spin: ""
    }, null, 8 /* PROPS */, ["size"])
  ]))
}
}

})